import { render } from "./MedicationCategoryCard.vue?vue&type=template&id=3726c03a"
import script from "./MedicationCategoryCard.vue?vue&type=script&lang=js"
export * from "./MedicationCategoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__